import { Component, OnInit, ViewChild, DebugNode } from '@angular/core';
import { SchoolDocumentUploadService } from './schooldocumentupload.service';
import { NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { global } from '../../shared/global';
import { Router, ActivatedRoute } from "@angular/router";
declare var $: any;

@Component({
  selector: 'app-schooldocumentupload',
  templateUrl: './schooldocumentupload.component.html',
  styleUrls: ['./schooldocumentupload.component.css']
})
export class SchooldocumentuploadComponent implements OnInit {
  @ViewChild('documentUpload') documentUploadForm: NgForm;
  // data: ScholarshipDetail;
  dropDownData: any;
  documentTypes: any
  responseData: any;
  schoolDocumentList: Array<any>;
  isDesc: boolean;
  column: string;
  p: number = 1;
  pageLimit = global.pageLimit;
  submitted: boolean;
  searchtext: any;
  HashCode: any;
  fileextension: any;
  doc: any;
  base64file: any;
  schoolname:any;
  sections:any;
  years:any;
  mediums:any;
  courses:any;
  visibleAmout:boolean=false;
  constructor(private service: SchoolDocumentUploadService, private toastr: ToastrService, private spinner: NgxSpinnerService, private router: Router, private rout: ActivatedRoute) { }

  ngOnInit(): void {
    if (localStorage.length == 0) {
      this.router.navigate(['/aciadmin']);
      return;
    }
    if (this.rout.snapshot.paramMap.has('ID')) {
      this.HashCode = this.rout.snapshot.paramMap.get('ID');
      this.schoolname = "- ("+ localStorage.getItem("SchoolName") +")";
      if (this.HashCode.trim() == "") {
        this.router.navigate(['/registrationlist']);
        return;
      }
    } else {
      this.router.navigate(['/registrationlist']);
      return;
    }
    this.fillSection();
    this.fillMedium();
    this.fillAcademicYear();
    this.fillDocument();
    this.SchoolDocumentList();
  }
  fillSection() {
    const data = {
      HashCode: this.HashCode
    };
    this.service.fillSection(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.sections = this.dropDownData.dropdownlist;
        this.documentUploadForm.controls["SectionID"].setValue(0);
      });
  }
  fillCourse() {
    const data = {
      streamID: this.documentUploadForm.controls["SectionID"].value
    };
    this.service.fillCourseByID(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.courses = this.dropDownData.dropdownlist;
        this.documentUploadForm.controls["CourseID"].setValue(0);
      });
  }
  fillMedium() {
    const data = {
    };
    this.service.fillMedium(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.mediums = this.dropDownData.dropdownlist;
        this.documentUploadForm.controls["MediumID"].setValue(0);
      });
  }
  fillAcademicYear() {
    const data = {
     // HashCode: this.HashCode
    };
    this.service.fillAcademicYear(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.years = this.dropDownData.dropdownlist;
        this.years.splice(0, 1);
        this.years.reverse();
        this.documentUploadForm.controls['AcademicYearID'].setValue(this.years.length);
      });
  }
  fillDocument() {
    const data = {
      //HashCode: this.HashCode
    };
    this.service.fillDocument(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.documentTypes = this.dropDownData.dropdownlist;
        this.documentUploadForm.controls["DocumentID"].setValue(0);
      });
  }
  SchoolDocumentList() {
    const data = {
      HashCode: this.HashCode
    };
    this.spinner.show();
    this.service.getSchoolDocumentList(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        this.schoolDocumentList = undefined
        if (this.responseData.tokenStatus == false) {
          localStorage.clear();
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/aciadmin']);
        }
        if(!this.responseData.userRightsStatus){
          this.toastr.error(this.responseData.message);
          return;
        }
        if (this.responseData.status == false) {
          //this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.schoolDocumentList = this.responseData.SchoolDocumentUploadLists;
          //this.toastr.success(this.responseData.message);
          //this.resetForm();
        }
      });
  }
  onSubmit() {
    this.submitted = true;
    if (this.documentUploadForm.controls["DocumentID"].value == 0 || this.base64file == null || this.fileextension == null) {
      return;
    }
    var amount;
    if(this.documentUploadForm.controls["Amount"] == undefined){
      amount = 0
    }else{
      amount = this.documentUploadForm.controls["Amount"].value;
    }
    if (this.visibleAmout && (amount == undefined || amount.toString().trim() == ""
      || parseFloat(amount.toString().trim()) <= 0)) {
      this.toastr.error("Enter amout");
      return;
    }
    if (this.visibleAmout = false) {
      //this.documentUploadForm.controls["Amount"].value("");
      amount = 0
    }
    if (this.documentUploadForm.valid) {
      this.spinner.show();
      const data = {
        HashCode: this.HashCode,
        DocumentID: this.documentUploadForm.controls["DocumentID"].value,
        SectionID: this.documentUploadForm.controls["SectionID"].value,
        AcademicYearID: this.documentUploadForm.controls["AcademicYearID"].value,
        StandardID: this.documentUploadForm.controls["CourseID"].value,
        MediumID: this.documentUploadForm.controls["MediumID"].value,
        Amount: amount,
        Base64File: this.base64file,
        FileExtension: this.fileextension
      };
      this.service.saveSchoolDocument(data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.tokenStatus == false) {
            localStorage.clear();
            this.toastr.error(this.responseData.message);
            this.router.navigate(['/aciadmin']);
          }
          if(!this.responseData.userRightsStatus){
            this.toastr.error(this.responseData.message);
            return;
          }
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.toastr.success(this.responseData.message);
            this.SchoolDocumentList();
            this.resetForm();
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/aciadmin']);
        });
    }
  }
  deleteDocument(HashCode, filePath) {
    var a = confirm("Are you sure you want to delete ?");
    if (a) {
      const data = {
        HashCode: HashCode,
        FilePath: filePath
      };
      this.spinner.show();
      this.service.deleteSchoolDocumentUpload(data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.tokenStatus == false) {
            localStorage.clear();
            this.toastr.error(this.responseData.message);
            this.router.navigate(['/aciadmin']);
          }
          if(!this.responseData.userRightsStatus){
            this.toastr.error(this.responseData.message);
            return;
          }
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.toastr.success(this.responseData.message);
            this.SchoolDocumentList();
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/aciadmin']);
        });
    }
  }
  uploadImage(event) {
    if (event.target.files.length > 0) {
      this.doc = event.target.files[0];
      if (Math.round(this.doc.size / 1024) > 1000) {
        this.toastr.error("File size can't be greater then 1 MB");
        return;
      }
      this.fileextension = this.doc.name.split('.');
      if (this.fileextension[this.fileextension.length - 1].toString().toLowerCase() != "jpg" && this.fileextension[this.fileextension.length - 1].toString().toLowerCase() != "png"
        && this.fileextension[this.fileextension.length - 1].toString().toLowerCase() != "jpeg" && this.fileextension[this.fileextension.length - 1].toString().toLowerCase() != "pdf") {
        this.toastr.error("You can upload only jpg, jpeg, png or pdf file");
        return;
      }
      //   if (this.fileextension[this.fileextension.length - 1] == "pdf") {
      //     document.getElementById("preview_" + i).setAttribute("src", "/assets/images/pdfimage.jpg");
      //   }
      //   //else {
      const [file] = event.target.files;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        //this.base64file = reader.result as string;
        var base64file = reader.result as string;
        this.base64file = base64file;
        this.fileextension = "." + this.fileextension[this.fileextension.length - 1].toString().toLowerCase();
      }
    } else {
      this.base64file = null;
      this.fileextension = null;
    }
  }
  resetForm() {
    this.submitted = false;
    this.base64file = null;
    this.fileextension = null;
    $("#customFile").val('');
    this.documentUploadForm.controls["MediumID"].setValue("0");
    this.documentUploadForm.controls["SectionID"].setValue("0");
    $('#CourseID option').remove();
    this.documentUploadForm.controls["AcademicYearID"].setValue(this.years.length.toString());
    this.documentUploadForm.controls["DocumentID"].setValue("0");
  }
  sortBy(field: string) {
    this.isDesc = !this.isDesc;
    this.column = field;
    let direction = this.isDesc ? 1 : -1;

    this.schoolDocumentList.sort(function (a, b) {
      if (a[field] < b[field]) {
        return -1 * direction;
      }
      else if (a[field] > b[field]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }
  setpage() {
    this.p = 1;
  }
  Cancel() {
    this.router.navigate(['/registrationlist']);
  }
  displayAmout(){
    var documentID=  this.documentUploadForm.controls["DocumentID"].value;
    if(documentID == "2"){
      this.visibleAmout=true;
    }else{
      this.visibleAmout=false;
    }
  }
  onlyDouble(evt) {
    var AcademicYearID=  this.documentUploadForm.controls["Amount"].value;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
    if (charCode == 46 && AcademicYearID != undefined && String(AcademicYearID).includes('.'))
      return false;
    var i = String(AcademicYearID).indexOf('.');
    if (i > 0 && String(AcademicYearID).length > i + 2)
      return false
    return true;
  }
}
